/* Earth Energy — Advertorial FAQ accordion */
(function(){
  function init(root){
    root.querySelectorAll('.faq-item button').forEach(function(b){
      b.addEventListener('click',function(){
        var it=b.parentElement, a=it.querySelector('.a'), open=it.classList.contains('open');
        root.querySelectorAll('.faq-item.open').forEach(function(o){o.classList.remove('open');o.querySelector('.a').style.maxHeight=null;});
        if(!open){it.classList.add('open');a.style.maxHeight=a.scrollHeight+'px';}
      });
    });
  }
  document.querySelectorAll('.ee-adv').forEach(init);
})();
